<template>
    <div class="px-4">
        <h4 class="text-center">
            <b> DEPOSITOS A CAJA DESDE OTRA SEDE </b>
        </h4> 
        
        
        <v-data-table :loading="loading" :headers="headers" :items="desserts" disable-pagination hide-default-footer :items-per-page="5" class="elevation-1">
            <template v-slot:[`item.estado`]="{ item }">
                <p class=""> {{ getEstado(item.estado) }} </p>
            </template>
            <template v-slot:[`item.monto_depositado`]="{ item }">
                <p> {{ item.monto_depositado }} bs </p>
            </template>
            <template v-slot:[`item.sede`]="{ item }">
                <p> {{ item.sede?item.sede.nombre:'' }} </p>
            </template>
            <template v-slot:[`item.sede_caja`]="{ item }">
                <p> {{ item.sede_caja?item.sede_caja.nombre:'' }} </p>
            </template>
            <template v-slot:[`item.monto_recaudado`]="{ item }">
                <p> {{ item.monto_recaudado }} bs </p>
            </template>
            <template v-slot:[`item.opt`]="{ item }">
                <div style="min-width: 150px;"> 
                    <v-btn tile small text color="orange" @click="obtenerDetalles(item.id)"> <v-icon>mdi-eye</v-icon> </v-btn>
                    <!-- <v-btn tile small text color="red" :disabled="!item.estado" @click="opencierre(item)"> <v-icon>mdi-close</v-icon> </v-btn> -->
                    <!-- <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }"> 
                            <v-btn  v-bind="attrs" v-on="on" tile small text color="blue" @click="$router.push('/depositos?idcaja='+item.id)"> <v-icon>mdi-file</v-icon> </v-btn>
                        </template>
                        <span> Disponible cuando se cierre las cajas </span>
                    </v-tooltip>  -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="item.estado==3" v-bind="attrs" v-on="on" tile small text color="blue" @click="verificaropen(item)"> <v-icon>mdi-check</v-icon> </v-btn>
                        </template>
                        <span> Verificar </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }"> 
                            <v-btn  v-bind="attrs" v-on="on" tile small text color="blue" @click="$router.push('/depositostodepos?idcaja='+item.caja_id+'&depoid='+item.id+'&other=1')"> <v-icon>mdi-file</v-icon> </v-btn>
                        </template>
                        <span> Depositos del deposito </span>
                    </v-tooltip>

                </div>
            </template>
        </v-data-table> 

        <v-dialog dark v-model="dialog" width="700"> 
            <v-card>
                <v-card-title class="text-h5" style="background-color: #161d30;">
                    <p class="text-center ma-0"> Detalles del deposito realizado.  </p>
                </v-card-title>

                <v-card-text style="background-color: #283045;"> 
                    <p class="my-0"> <b>Creado por: </b> {{ dialogitem.created_by }} </p>
                    <div class="row">
                        <div class="cols-12 col-sm-6">
                            <p class="my-0"> <b>Caja id: </b> {{ dialogitem.caja_id }} </p>
                            <p class="my-0"> <b>Sede: </b> {{ dialogitem.sede?dialogitem.sede.nombre:'' }} </p>
                            <p class="my-0"> <b>Usuario id: </b> {{ dialogitem.user_id }} </p>
                            <p class="my-0"> <b>Cuenta bancaria id: </b> {{ dialogitem.cuenta_bancaria_id }} </p>
                            <p class="my-0"> <b>Estado: </b> {{ dialogitem.estado?'Activo':'Inactivo' }} </p>
                            <p class="mt-0 mb-8"> <b>Verificado por: </b> {{ dialogitem.verificado_by }} </p>
                        </div>
                        <div class="cols-12 col-sm-6">
                            <p class="my-0"> <b>Monto recaudado: </b> {{ dialogitem.monto_recaudado }} bs </p>
                            <p class="my-0"> <b>Monto depositado: </b> {{ dialogitem.monto_depositado }} bs </p>
                            <p class="my-0"> <b>Fecha deposito: </b> {{ dialogitem.fecha_deposito }} </p>
                            <p class="my-0"> <b>Fecha verificacion: </b> {{ dialogitem.fecha_verificacion }} </p>
                            <p class="my-0"> <b>Comprobante: </b> {{ dialogitem.comprobante }} </p>
                            <p class="my-0"> <b>Creado: </b> {{ dialogitem.created_at }} </p>
                        </div>
                    </div> 

                    <small> Imagen del comprobante: </small> 
                    <small> {{ dialogitem.archivo?dialogitem.archivo.extencion:''}} </small>
                    <small> {{ dialogitem.archivo?dialogitem.archivo.mimeType:''}} </small>
                    <p v-if="!dialogitem.archivo" class="red--text">
                        <small> No hay comprobante :) </small>
                    </p>
                    <div class="text-center">
                        <object :data="getdatauri(dialogitem.archivo)" type="image/png" width="500"></object>
                    </div>
                    <v-btn v-if="dialogitem.archivo" small :disabled="loading" :loading="loading" tile color="orange" class="mr-4" @click="saveArchivo()" > descargar comprobante </v-btn>


                    <div class="row justify-center mt-6">
                        <v-btn tile small color="green" @click="dialog=!dialog"> <v-icon>mdi-close</v-icon> cerrar </v-btn>
                    </div>
                </v-card-text> 
            </v-card>
        </v-dialog>
    </div>
  </template>

<script>
import xaxios from '@/xaxios';

export default {
    components:{},
    data () {
        return {
            headers: [ 
                { text: '#', value: 'nro' },
                { text: 'Creado por', value: 'created_by' }, 
                { text: 'en fecha', value: 'created_at' },
                { text: 'Monto depositado', value: 'monto_depositado' },
                { text: 'Monto recaudado', value: 'monto_recaudado' }, 
                { text: 'estado', value: 'estado' }, 
                { text: 'sede origen', value: 'sede_caja' }, 
                { text: 'sede destino', value: 'sede' }, 
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
            dialog: false,
            dialogitem:{},
        }
    },
    watch:{ 
        '$store.state.CARGO': function(){
            this.cargarDatos();
        }
    },
    methods:{
        async cargarDatos(){
            this.loading = true;
            this.desserts = [];
            let idsede = this.$store.state.CARGO.sede.id;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${idsede}/sede`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            // window.console.log('sededestinos:', res.data);
            if(res && res.data ) {
                res.data.map((x,i)=>{
                    x,
                    x.nro = i+1
                })
                this.desserts = res.data;
            } 
            this.loading = false;
        },
        async obtenerDetalles(depoid){
            this.loading = true;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${depoid}`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ){
                // window.console.log('res',res.data);  
                this.dialogitem = {...res.data};
            }
            this.loading = false;
            this.dialog = true;
        }, 
        getdatauri(archivo){
            if(!archivo) return '';
            return `data:${archivo.mimetype};base64,${archivo.file64}`
        },
        getEstado(est){
            if (est == 1) return 'recaudado';
            else if (est == 2) return 'depositado';
            else if (est == 3) return 'verificado';
            else return '??';
        },
        saveArchivo(){
            /* var link = document.createElement("a");
            link.download = "deposito.docx";
            link.href = this.dialogitem.archivo;
            link.click(); */

            const base64String = this.dialogitem.archivo.file64
            const ext = this.dialogitem.archivo.extencion
            window.console.log('base64String',this.dialogitem.archivo);
            
            // Intentar extraer el tipo MIME y la parte Base64 real
            let mimeType = 'application/octet-stream'; // Valor por defecto si no se encuentra
            let base64Data = base64String;
            let suggestedExtension = '';

            const mimeMatch = base64String.match(/^data:(.*?);base64,/);
            if (mimeMatch && mimeMatch[1]) {
                mimeType = mimeMatch[1];
                base64Data = base64String.split(',')[1];

                // Intentar inferir la extensión del archivo del tipo MIME
                const parts = mimeType.split('/');
                if (parts.length > 1) {
                    // Casos especiales para extensiones comunes
                    if (parts[0] === 'image' && parts[1] === 'jpeg') {
                        suggestedExtension = '.jpg';
                    } else if (parts[0] === 'image' && parts[1] === 'svg+xml') {
                        suggestedExtension = '.svg';
                    } else if (parts[0] === 'application' && parts[1] === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                        suggestedExtension = '.xlsx';
                    } else if (parts[0] === 'application' && parts[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
                        suggestedExtension = '.docx';
                    } else {
                        suggestedExtension = '.' + parts[1]; // Generalmente la segunda parte del MIME es la extensión
                    }
                }
            }

            if(ext == "zip") suggestedExtension = ".docx"
            if(ext == "jpg") suggestedExtension = ".jpg"

            // Decodificar el string Base64 a un ArrayBuffer
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Crear un Blob
            const blob = new Blob([byteArray], { type: mimeType });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            // Usar el nombre de archivo proporcionado o uno generado
            a.download = `deposito__${suggestedExtension || ''}`;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },

        async verificaropen(item){
            // window.console.log('item',item);
            let message = {
                title: 'Para indicar como verificado, valide esta accion:',
                body: '<br> <b>NOTA:</b> Primero verifique el comprobante(con el boton del ojito) que este correcto y luego confirme la verificacion, es su responsabilidad marcar verificado ',
            };
            let options = {
                html: true,
                okText: 'Verificado',
                cancelText: 'Cancelar',
                reverse: true,
                type: 'hard',
                verification: 'verificado',
                verificationHelp: 'Escriba "[+:verification]" para proceder.',
                loader: true,
            };
            let dialogo = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
            if(dialogo){
                // 
                let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${item.id}`; 
                const res = await xaxios.patch(url).then(x=>x).catch(x=>x);
                window.console.log(res);
                dialogo.close();
                this.cargarDatos();
            }
            // window.console.log('dialogo',dialogo)
        },
        
    },
    async mounted(){ 
        this.cargarDatos();
        
    }
}
</script>